const encodeToTag = (message_rich: string) => {
  return message_rich.replace(/!\[(.*?)\]\((data:image\/[^;]+;base64,[^)]+)\)/g, (_match, _alt, src) => {
    return `<data:image/png;base64,${src.split(",")[1]}data:image/png;>`
  })
}

export default encodeToTag
